// WAG Universal Product Image Zoom (theme-agnostic)
(() => {
  const SELECTORS = [
    // Common product media areas across themes
    '.product__media img',
    '.product-media img',
    '.product__media-item img',
    'media-gallery img',
    '.media-gallery img',
    '.product-gallery img'
  ];

  const isLikelyProductPage = () => {
    // Basic check: product page usually has a product form or media gallery
    return document.querySelector('form[action*="/cart/add"]') || document.querySelector('media-gallery') || document.querySelector('.product__media');
  };

  const ensureOverlay = () => {
    let overlay = document.getElementById('wagZoomOverlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'wagZoomOverlay';
    overlay.innerHTML = `
      <div class="wagZoomInner" role="dialog" aria-modal="true" aria-label="Image zoom">
        <button class="wagZoomClose" type="button" aria-label="Close">✕</button>
        <img class="wagZoomImg" alt="" />
        <div class="wagZoomHint">Scroll to zoom • Drag to move • ESC to close</div>
      </div>
    `;
    document.body.appendChild(overlay);

    const img = overlay.querySelector('.wagZoomImg');
    const closeBtn = overlay.querySelector('.wagZoomClose');

    const close = () => {
      overlay.classList.remove('is-open');
      img.src = '';
      img.alt = '';
      img.style.transform = 'scale(1) translate(0px, 0px)';
      scale = 1;
      tx = 0;
      ty = 0;
    };

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    // zoom + pan
    let scale = 1, tx = 0, ty = 0;
    let dragging = false, startX = 0, startY = 0;

    const applyTransform = () => {
      img.style.transform = `scale(${scale}) translate(${tx}px, ${ty}px)`;
    };

    overlay.addEventListener('wheel', (e) => {
      if (!overlay.classList.contains('is-open')) return;
      e.preventDefault();
      const delta = Math.sign(e.deltaY) * -0.12;
      scale = Math.min(5, Math.max(1, +(scale + delta).toFixed(2)));
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform();
    }, { passive: false });

    img.addEventListener('mousedown', (e) => {
      if (scale <= 1) return;
      dragging = true;
      img.style.cursor = 'grabbing';
      startX = e.clientX;
      startY = e.clientY;
    });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const dx = (e.clientX - startX) / scale;
      const dy = (e.clientY - startY) / scale;
      startX = e.clientX;
      startY = e.clientY;
      tx += dx;
      ty += dy;
      applyTransform();
    });

    window.addEventListener('mouseup', () => {
      dragging = false;
      img.style.cursor = 'grab';
    });

    overlay.__wagClose = close;
    overlay.__wagSetImage = (src, alt) => {
      img.src = src;
      img.alt = alt || '';
      overlay.classList.add('is-open');
    };

    return overlay;
  };

  const bestSrc = (imgEl) => {
    // Prefer srcset largest if present; otherwise currentSrc/src
    if (imgEl && imgEl.srcset) {
      const parts = imgEl.srcset.split(',').map(s => s.trim());
      const last = parts[parts.length - 1];
      const url = last.split(' ')[0];
      return url || imgEl.currentSrc || imgEl.src;
    }
    return imgEl.currentSrc || imgEl.src;
  };

  const bind = (root = document) => {
    if (!isLikelyProductPage()) return;

    const overlay = ensureOverlay();
    const imgs = SELECTORS
      .flatMap(sel => Array.from(root.querySelectorAll(sel)))
      .filter(img => img && img.tagName === 'IMG');

    imgs.forEach((img) => {
      // prevent double-binding
      if (img.dataset.wagZoomBound === '1') return;
      img.dataset.wagZoomBound = '1';
      img.classList.add('wag-zoomable');

      img.addEventListener('click', (e) => {
        // Don’t hijack clicks on thumbnails inside links unless wanted
        e.preventDefault();
        e.stopPropagation();
        const src = bestSrc(img);
        overlay.__wagSetImage(src, img.alt);
      });
    });
  };

  // Initial bind
  document.addEventListener('DOMContentLoaded', () => bind(document));

  // Re-bind when Shopify renders sections dynamically (variant change, etc.)
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
  document.addEventListener('shopify:section:reorder', (e) => bind(e.target));
})();
